import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import SessionCard from '../../components/card/session-card';
import hubspot from '../../modules/hubspot';
import { BorrowerCard } from '../card-lenses';
import { ContactInfo, nameValidator } from '.';

const ExpiringVisaShortCard = ({ onSubmit, ...props }) => (
  <ContactInfo
    {...props}
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.registerExpiringVisaLead(props.model.get('email'), {
          name: props.model.get('name'),
          scenario: props.scenario,
          loan_state: props.questionnaireState, // eslint-disable-line @typescript-eslint/camelcase
          don_t_send_monthly_newsletter: true // eslint-disable-line @typescript-eslint/camelcase
        });
        onSubmit();
      })
    }
    buttonType="end"
    title={
      "Unfortunately, our lenders don't offer loans to borrowers with a visa that expires in less than 12 months. Please leave us your email and we'll send you a note if that changes."
    }
  />
);

export const ExpiringVisaContactInfo = SessionCard(
  BorrowerCard(
    ExpiringVisaShortCard,
    'ExpiringVisaContactInfo',
    {},
    ({ model }) =>
      nameValidator(model.get('name')) && emailValidator.validate(model.get('email') || '')
  )
);



// WEBPACK FOOTER //
// ./src/cards/contact-info-short/expiring-visa.js